export default __webpack_public_path__ + "static/media/image 117.be7c6017.png";